import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 47px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 16px;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Logo = styled.img`
  height: 56px;
  margin-right: 8px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  color: #000000;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  line-height: 56px;
  min-width: 70px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  color: #d0fb0c;
  display: flex;
  font-weight: bold;
  justify-content: center;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  background: #000000;
  height: 100%;
  margin: 0 3px;
  width: 2px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamColor = styled.div`
  width: 16px;
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  align-items: center;
  background: #2f3336;
  color: #ffffff;
  display: flex;
  font-size: 43px;
  font-style: normal;
  font-weight: normal;
  justify-content: center;
  line-height: 56px;
  min-width: 115px;
  padding: 0 16px;
  position: relative;

  &:first-child {
    margin-right: 2px;
  }

  &:last-child {
    margin-left: 2px;
  }
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #030303;
  border-bottom: 4px solid #fa6e07;
  box-sizing: content-box;
  display: flex;
  height: 56px;
  justify-content: center;
  min-width: 185px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #ffffff;
  font-size: 48px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.03em;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';
